export default __webpack_public_path__ + "static/media/toolsDark.75126e66.png";